module.exports = __webpack_public_path__ + "images/xllease3e68872df48f26975c1b57d92e1945d8.png";